import { MarkdownBlock } from './markdown-block';
import { ImageBlockImage, ImageBlock } from './images-block';
import { ContentBlockTypes } from './content-block-types';
import { TickerBlock } from './ticker-block';

const contentSeperator = '\n';

export type ContentBlock = MarkdownBlock | ImageBlock | TickerBlock;

export function createMarkdownBlock(markdown: string = ''): MarkdownBlock {
  return {
    type: ContentBlockTypes.Markdown,
    markdown,
  };
}

export function createImagesBlock(images: ImageBlockImage[]): ImageBlock {
  return {
    type: ContentBlockTypes.Images,
    images: images,
  };
}

// extract markdown text from content blocks
export function extractContentBlockText(contentBlocks: ContentBlock[]): string {
  if (!contentBlocks) {
    return '';
  }

  return contentBlocks
    .filter((block: ContentBlock) => block.type === ContentBlockTypes.Markdown)
    .map((block: MarkdownBlock) => block.markdown)
    .join(contentSeperator);
}
